import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {    Box,
    Collapse,    IconButton,
    LinearProgress, Paper, Table,
    TableBody, TableCell, TableContainer,
    TableHead,TableRow, Tooltip,
    Typography,
} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
 
import CreateIcon from '@material-ui/icons/Create';
import {ErrorGeneral, llamaApiCargaToken} from '../funciones/ClienteAxios';

const useStyles = makeStyles({
    root: {
        width: '15rem',
    },
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaObra({ listBit, obraRegis, setObraRegis }) {
    const classes = useStyles();
    let history = useHistory();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const [registro, setRegistro] = useState([]);
    const [open, setOpen] = useState(false);
    const [espera, setEspera] = useState(false);
    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [seleccionadoEdit, setSeleccionadoEdit] = useState([]);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(true)    

    useEffect(() => {
        if (listBit.length!==0) {
            seleccionado(listBit[0])    
        }                  
        
        guardarDatos(listBit)
        return () => {
            source.cancel();
        }
    }, [listBit]);

    const seleccionado = (auxReg) => {
        setRegistro(auxReg)      
        setObraRegis(auxReg) 
    }

    function editarFall(auxFalla) {
        setSeleccionadoEdit(auxFalla)

        setModalAbierto(true)
    }

    function verMas(auxId) {

        if (auxId === ordenSelecc) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }

    const minuscula=(cadena)=>{
        let nvo=""
        nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
        return nvo}

    function Row(props) {
        const {row} = props;

        return (
        <>
            <TableRow onClick={() => { seleccionado(row); }}
                className={classes.tableRow} selected={registro?.Id === row.Id}
                classes={{hover: classes.hover, selected: classes.selected}}
            >          
              {/*   <TableCell className={classes.tableCell} align="center" padding={'none'}
                    style={{fontWeight: 700, width: 100 + 'px'}}>
                    {row.Id}
                </TableCell> */}
                <TableCell className={classes.tableCell} align="left" padding={'none'} style={{width: 150 + 'px', paddingLeft:".7rem"}}>
                    {row.Id ===0 ? "TODOS":row.Descr }
                </TableCell>
                <TableCell align="center" style={{color: registro?.Id === row.Id?"white" :row.StatusCol,  width: 50 + 'px'}}
                    padding={'none'}>
                        {row.Total}
                </TableCell>
                
            </TableRow>
            
        </>
        );
    }

    function tablaCompleta(auxlista) {
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" padding='none'>{`${auxlista.length} Ubicación`}</TableCell>                      
                    <TableCell align="center" padding='none'>Total </TableCell>                                                              
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length !== 0 ? (auxlista.map((row) => (
                    <Row key={row.Id} row={row}/>
                ))) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
        <TableContainer className={classes.container2}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">  </TableCell>
                        <TableCell align="left">Fecha</TableCell>
                        <TableCell align="left">Estatus</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow  className={classes.tableRow} >
                        <TableCell className={classes.tableCell} align="center"></TableCell>
                        <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                        <TableCell className={classes.tableCell} align="left">Registros</TableCell>

                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        )
    }

    const tablaSinResultados = () => {
        return (
        <TableContainer className={classes.container2}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">  </TableCell>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Estatus</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow} >
                    <TableCell className={classes.tableCell} align="center"> </TableCell>
                    <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                    <TableCell className={classes.tableCell} align="left">coincidencias</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        </TableContainer>
        )
    }
    
    const contenido = datos.length !== 0 && datos[0].Id !== "-1" &&datos[0].Id !== -1 ? tablaCompleta(datos) : tablaSinDatos()
    const tabla = espera ? (<Box style={{paddingTop:"5rem"}} ><LinearProgress/> </Box>) : (contenido)
 
    return (
    <Paper className={classes.root}>
        <Typography style={{marginLeft:".7rem"}}> Obras</Typography>
        {tabla}
        
    </Paper>
    );
}